var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-degrade"},[_c('b-container',{staticClass:"source-sans shadow mt-0 mt-md-3 mb-0 mb-md-4 mb-lg-5 px-3 px-lg-5 pt-2 pt-md-5 pb-4 pb-lg-5 bg-white"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69f4a46e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-carousel-slide":"img-src"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wrapper/Section.vue
// module id = RCWh
// module chunks = 1